export var ExercisePerformanceType;
(function (ExercisePerformanceType) {
    ExercisePerformanceType["REPITITION"] = "REPITITION";
    ExercisePerformanceType["TIME"] = "TIME";
})(ExercisePerformanceType || (ExercisePerformanceType = {}));
//# sourceMappingURL=exercise-performance-type.enum.js.map